exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.categoryoption.lowerCase .el-select-dropdown__item{text-transform:inherit !important\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/components/common/FilterDropdown.vue"],"names":[],"mappings":";AACA,oDAAoD,iCAAiC;CACpF","file":"FilterDropdown.vue","sourcesContent":["\n.categoryoption.lowerCase .el-select-dropdown__item{text-transform:inherit !important\n}"],"sourceRoot":""}]);

// exports
